import * as tslib_1 from "tslib";
import { ImageStretchOptions_$type } from "./ImageStretchOptions";
import { EditorType_$type } from "./EditorType";
import { IgrColumn } from "./igr-column";
import { ImageColumn } from "./ImageColumn";
import { ensureEnum } from "igniteui-react-core";
/**
 * Represents an Image grid column, used to allow the developer to display an image in a cell.
*/
var IgrImageColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrImageColumn, _super);
    function IgrImageColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrImageColumn.prototype.createImplementation = function () {
        return new ImageColumn();
    };
    Object.defineProperty(IgrImageColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "imageStretchOption", {
        /**
         * Gets or sets the stretch option to use when rendering images
        */
        get: function () {
            return this.i.j7;
        },
        set: function (v) {
            this.i.j7 = ensureEnum(ImageStretchOptions_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorType", {
        /**
         * Gets or sets the editor type used for editing cells in this column.
        */
        get: function () {
            return this.i.j3;
        },
        set: function (v) {
            this.i.j3 = ensureEnum(EditorType_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorDataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.j8;
        },
        set: function (v) {
            this.i.j8 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorTextField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.j9;
        },
        set: function (v) {
            this.i.j9 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorValueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.j2;
        },
        set: function (v) {
            this.i.j2 = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrImageColumn;
}(IgrColumn));
export { IgrImageColumn };
//# sourceMappingURL=igr-image-column.js.map
